import { lazy } from "react";
import WithSuspense from "../components/loaders/WithSuspense";
import { PUBLIC_PATHS, PRIVATE_PATHS } from "./constants";
import { Navigate } from "react-router-dom";

const Login = WithSuspense(lazy(() => import("../pages/Auth/Login")));
const ForgotPassword = WithSuspense(
  lazy(() => import("../pages/Auth/ForgotPassword")),
);
const UpdatePassword = WithSuspense(
  lazy(() => import("../pages/Auth/UpdatePassword")),
);
const Dashboard = WithSuspense(lazy(() => import("../pages/Dashboard")));
const Staff = WithSuspense(lazy(() => import("../pages/Staff")));
const StaffDetails = WithSuspense(
  lazy(() => import("../pages/Staff/StaffDetails")),
);
const ClientMgt = WithSuspense(lazy(() => import("../pages/ClientMgt")));
const Clients = WithSuspense(lazy(() => import("../pages/ClientMgt/Clients")));
const ClientServices = WithSuspense(
  lazy(() => import("../pages/ClientMgt/Services")),
);
const Leads = WithSuspense(lazy(() => import("../pages/ClientMgt/Leads")));
const LeadDetails = WithSuspense(
  lazy(() => import("../pages/ClientMgt/LeadDetails")),
);
const AssignLead = WithSuspense(
  lazy(() => import("../pages/ClientMgt/AssignLead")),
);
const CreateLead = WithSuspense(
  lazy(() => import("../pages/ClientMgt/CreateLead")),
);
const AccMgt = WithSuspense(lazy(() => import("../pages/AccMgt")));
const AccMgtDetails = WithSuspense(
  lazy(() => import("../pages/AccMgt/AccMgtDetails")),
);
const CreateAccount = WithSuspense(
  lazy(() => import("../pages/AccMgt/CreateAccount")),
);
const Department = WithSuspense(
  lazy(() => import("../pages/Settings/Department")),
);
const Strategy = WithSuspense(lazy(() => import("../pages/Settings/Strategy")));
const Permission = WithSuspense(
  lazy(() => import("../pages/Settings/Permission")),
);
const AddPermission = WithSuspense(
  lazy(() => import("../pages/Settings/Permission/AddPermission")),
);
const SystemRoles = WithSuspense(
  lazy(() => import("../pages/Settings/SystemRoles")),
);
const AddRole = WithSuspense(
  lazy(() => import("../pages/Settings/SystemRoles/AddRole")),
);
const EditRole = WithSuspense(
  lazy(() => import("../pages/Settings/SystemRoles/EditRole")),
);
const EditPermission = WithSuspense(
  lazy(() => import("../pages/Settings/Permission/EditPermission")),
);
const JobTitle = WithSuspense(lazy(() => import("../pages/Settings/JobTitle")));
const WorkLog = WithSuspense(lazy(() => import("../pages/WorkLog")));
const DigitalMarketer = WithSuspense(
  lazy(() => import("../pages/WorkLog/DigitalMarketer")),
);
const FinanceActivity = WithSuspense(
  lazy(() => import("../pages/WorkLog/FinanceActivity")),
);
const SalesActivity = WithSuspense(
  lazy(() => import("../pages/WorkLog/SalesActivity")),
);
const AddNewLog = WithSuspense(
  lazy(() => import("../pages/WorkLog/AddNewLog")),
);
const OperationsLog = WithSuspense(
  lazy(() => import("../pages/WorkLog/Operations/OperationsLog")),
);
const DigitalMarketerLog = WithSuspense(
  lazy(() => import("../pages/WorkLog/DigitalMarketer/DigitalMarketerLog")),
);
const FinancialActivityLog = WithSuspense(
  lazy(() => import("../pages/WorkLog/FinanceActivity/FinancialActivityLog")),
);
const SalesActivityLog = WithSuspense(
  lazy(() => import("../pages/WorkLog/SalesActivity/SalesActivityLog")),
);

export const PUBLIC_ROUTES = [
  { path: PUBLIC_PATHS.LOGIN, element: <Login /> },
  { path: PUBLIC_PATHS.UPDATE_PASSWORD, element: <UpdatePassword /> },
  { path: PUBLIC_PATHS.FORGOT_PASSWORD, element: <ForgotPassword /> },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

export const PRIVATE_ROUTES = [
  { path: PRIVATE_PATHS.DASHBOARD, element: <Dashboard /> },
  { path: PRIVATE_PATHS.STAFF, element: <Staff /> },
  { path: PRIVATE_PATHS.STAFF_DETAILS, element: <StaffDetails /> },
  { path: PRIVATE_PATHS.WORK_LOG, element: <WorkLog /> },
  { path: PRIVATE_PATHS.DIGITAL_MARKETER, element: <DigitalMarketer /> },
  { path: PRIVATE_PATHS.FNANCE_ACTIVITY, element: <FinanceActivity /> },
  { path: PRIVATE_PATHS.SALES_ACTIVITY, element: <SalesActivity /> },
  { path: PRIVATE_PATHS.ADD_NEW_LOG, element: <AddNewLog /> },
  { path: PRIVATE_PATHS.OPERATIONS_LOG, element: <OperationsLog /> },
  { path: PRIVATE_PATHS.DIGITAL_MARKETER_LOG, element: <DigitalMarketerLog /> },
  {
    path: PRIVATE_PATHS.FINANCIAL_ACTIVITY_LOG,
    element: <FinancialActivityLog />,
  },
  { path: PRIVATE_PATHS.SALES_ACTIVITY_LOG, element: <SalesActivityLog /> },
  { path: PRIVATE_PATHS.ACC_MGT, element: <AccMgt /> },
  { path: PRIVATE_PATHS.ACC_MGT_CREATE_ACCOUNT, element: <CreateAccount /> },
  { path: PRIVATE_PATHS.ACC_MGT_DETAILS, element: <AccMgtDetails /> },
  { path: PRIVATE_PATHS.CLIENT_MGT, element: <ClientMgt /> },
  { path: PRIVATE_PATHS.CLIENT_MGT_CLIENTS, element: <Clients /> },
  { path: PRIVATE_PATHS.CLIENT_MGT_SERVICES, element: <ClientServices /> },
  { path: PRIVATE_PATHS.CLIENT_MGT_LEADS, element: <Leads /> },
  { path: PRIVATE_PATHS.CLIENT_MGT_LEAD_DETAILS, element: <LeadDetails /> },
  {
    path: PRIVATE_PATHS.CLIENT_MGT_ASSIGN_LEAD_DETAILS,
    element: <AssignLead />,
  },
  { path: PRIVATE_PATHS.CLIENT_MGT_CREATE_LEAD, element: <CreateLead /> },
  { path: PRIVATE_PATHS.DEPTS, element: <Department /> },
  { path: PRIVATE_PATHS.PERMISSIONS, element: <Permission /> },
  { path: PRIVATE_PATHS.ADD_PERMISSION, element: <AddPermission /> },
  { path: PRIVATE_PATHS.STRATEGY, element: <Strategy /> },
  { path: PRIVATE_PATHS.SYSTEM_ROLES, element: <SystemRoles /> },
  { path: PRIVATE_PATHS.ADD_ROLES, element: <AddRole /> },
  { path: PRIVATE_PATHS.EDIT_ROLES, element: <EditRole /> },
  { path: PRIVATE_PATHS.EDIT_PERMISSION, element: <EditPermission /> },
  { path: PRIVATE_PATHS.JOB_TTILES, element: <JobTitle /> },
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />,
  },
];
